import { createTheme } from '@mui/material/styles'
import { components } from './components'

/**
 * Customized Material UI theme.
 *
 * @see https://next.material-ui.com/customization/default-theme/
 */
export default createTheme(
  {
    breakpoints: {
      values: {
        xs: 0,
        sm: 375,
        md: 768,
        lg: 1023,
        xl: 1536,
      },
    },

    palette: {
      primary: {
        main: 'rgb(24,119,242)',
      },
      background: {
        default: 'rgb(240,242,245)',
      },
    },

    typography: {
      fontFamily: [
        `"Beausite Classic"`,
        `-apple-system`,
        `"BlinkMacSystemFont"`,
        `"Segoe UI"`,
        `"Roboto"`,
        `"Oxygen"`,
        `"Ubuntu"`,
        `"Cantarell"`,
        `"Fira Sans"`,
        `"Droid Sans"`,
        `"Helvetica Neue"`,
        `sans-serif`,
      ].join(','),
    },

    components,
  },
  {
    typography: {
      h1: { fontSize: '2em' },
      h2: { fontSize: '1.5em' },
      h3: { fontSize: '1.3em' },
      h4: { fontSize: '1em' },
      h5: { fontSize: '0.8em' },
      h6: { fontSize: '0.7em' },
      button: { textTransform: 'none' },
    },
  },
)
